import { render, staticRenderFns } from "./PageActionBar.vue?vue&type=template&id=94386140&scoped=true&"
import script from "./PageActionBar.vue?vue&type=script&lang=ts&"
export * from "./PageActionBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94386140",
  null
  
)

export default component.exports